import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RFQFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  totalCount = 0 
}) => {
  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'quoted', label: 'Quoted' },
    { value: 'accepted', label: 'Accepted' },
    { value: 'declined', label: 'Declined' },
    { value: 'expired', label: 'Expired' }
  ];

  const categoryOptions = [
    { value: '', label: 'All Categories' },
    { value: 'consultancy', label: 'Consultancy' },
    { value: 'infrastructure', label: 'Infrastructure' },
    { value: 'networking', label: 'Networking' },
    { value: 'software', label: 'Software Development' },
    { value: 'policy', label: 'Policy & Strategy' },
    { value: 'integration', label: 'System Integration' }
  ];

  const dateRangeOptions = [
    { value: '', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' }
  ];

  const hasActiveFilters = filters?.search || filters?.status || filters?.category || filters?.dateRange;

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-muted-foreground" />
          <h3 className="text-lg font-semibold text-foreground">Filter RFQs</h3>
          <span className="text-sm text-muted-foreground">({totalCount} total)</span>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search RFQ number..."
          value={filters?.search || ''}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          placeholder="Filter by status"
          options={statusOptions}
          value={filters?.status || ''}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          placeholder="Filter by category"
          options={categoryOptions}
          value={filters?.category || ''}
          onChange={(value) => onFilterChange('category', value)}
        />

        <Select
          placeholder="Filter by date"
          options={dateRangeOptions}
          value={filters?.dateRange || ''}
          onChange={(value) => onFilterChange('dateRange', value)}
        />
      </div>
    </div>
  );
};

export default RFQFilters;